import { colors } from "#app/theme/v2/colors";

const AVATAR_HUES = ["green", "blue", "orange", "purple", "magenta", "beige"] as const;

export const getNestingItemColors = (index: number) => {
  const hue = AVATAR_HUES[index % AVATAR_HUES.length] ?? AVATAR_HUES[0];
  return { background: colors.bg.avatar[hue], text: colors.icon.avatar[hue] };
};
